import { MonitorCheckIcon, ScanLine, UserStarIcon } from "lucide-react";

import AdminCard from "./component/dashboard.card";
import Dashboard from "../dashboard/Dashboard";
import { Levels } from "../../services/admin.service";
import React from "react";
// import style from "./admin.module.scss";

const AdminDashboardPage = () => {
  return (
    <Dashboard pageTitle="Admin">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
        <AdminCard
          cardTitle="Root Admin"
          counter={5}
          icon={<UserStarIcon className="w-7 h-7" />}
          buttonText="Manage Users"
          url={`/admin/list?level=${Levels.ROOTADMIN}`}
        />
        <AdminCard
          cardTitle="Merchant Admin"
          counter={15}
          icon={<ScanLine className="w-7 h-7" />}
          buttonText="Manage Users"
          url={`/admin/list?level=${Levels.MERCHANT}`}
        />
        <AdminCard
          cardTitle="Finance Admin"
          counter={4}
          icon={<MonitorCheckIcon className="w-7 h-7" />}
          buttonText="Manage Users"
          url={`/admin/list?level=${Levels.FINANCE}`}
        />
      </div>
    </Dashboard>
  );
};

export default AdminDashboardPage;
